import { FC } from "react";
import { UserProfile } from "@/app/lib/features/auth/auth.types";
import { UserAvatar } from "./UserAvatar";
import Link from "next/link";

interface UserProfileHeaderProps {
  userProfile: UserProfile;
}

export const UserProfileHeader: FC<UserProfileHeaderProps> = ({
  userProfile,
}) => {
  return (
    <Link
      href="/account/profile"
      className="flex items-center gap-3 p-3 border-b border-gray-100 mb-2"
    >
      <UserAvatar
        firstname={userProfile.firstname}
        lastname={userProfile.lastname}
        profilePhotoUrl={userProfile.photo}
        size="md"
      />
      <div>
        <h3 className="font-semibold text-sm text-gray-900">
          {userProfile.full_name}
        </h3>
        <p className="text-xs text-gray-500">
          {userProfile.phone || userProfile.email}
        </p>
      </div>
    </Link>
  );
};
